/*
 * @Author: Json Chen
 * @Date: 2022-06-01 18:12:53
 * @LastEditTime: 2022-06-08 11:51:00
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/GiftCardAndStoreCredit/Detail/index.tsx
 */
//import css from './css.module.less';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getGiftCard, updateGiftCardStatus } from 'src/request/order';
import GiftCardInfo from './GiftCardInfo';
import IssueInfo from './IssueInfo';
import TopLeft from './TopLeft';
import Usage from './Usage';
import { useRequest } from 'ahooks';

const permissions = () => {
  const view_gift_card_store_credit_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.view_gift_card_store_credit_details_page,
      }),
    ],
  });
  return {
    view_gift_card_store_credit_details_page,
  };
};

const Detail = (props) => {
  const { view_gift_card_store_credit_details_page } = permissions();
  const { uuid }: any = useParams();
  const [data, setData] = React.useState(null);
  const [, setLoaded] = React.useState(false);
  React.useEffect(() => {
    if (view_gift_card_store_credit_details_page) {
      getGiftCard(uuid).then((res) => {
        // console.log('data', res);
        setData(res);
        setLoaded(true);
      });
    } else {
      setLoaded(true);
    }
  }, []);
  const { run } = useRequest(
    (status) => {
      const { uuid } = data;
      return updateGiftCardStatus({ uuid, status });
    },
    {
      manual: true,
      onSuccess: (res) => {
        setData(res);
      },
    },
  );
  //console.log('data123', data);
  const { transactions, timezone, currency, cardNo } = data || {};
  return (
    <Layout
      topLeft={<TopLeft name={cardNo} />}
      elements={[
        { child: <GiftCardInfo data={data} onChangeStatus={run} /> },
        { child: <IssueInfo data={data} onChange={setData} /> },
        {
          child: (
            <Usage
              list={transactions || []}
              timezone={timezone}
              currency={currency}
            />
          ),
        },
      ]}
    />
  );
};

export default Detail;
